import React, { Component, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import history from '../../../route/history'
import { regisActions, alertActions } from '../../../store/actions'
import KTnetModal2 from '../../../module/ktnet/KTnetModal2'
import KTnetModalExport from '../../../module/ktnet/KTnetModalExport'
import KTnetModalImport from '../../../module/ktnet/KTnetModalImport'
import Input from '../../../module/input'
import moment from 'moment'
import Alert from '../../../module/alert/Alert'
import { valid } from '../../../hook/valid'

const CrtfctStep02 = (props) => {
  // 공인인증 툴킷open 여부
  const [isKTnetOpen, setIsKTnetOpen] = useState(false)

  const [isKTnetOpenExport, setIsKTnetOpenExport] = useState(false)

  const [isKTnetOpenImport, setIsKTnetOpenImport] = useState(false)

  const [state, setState] = useState({
    isView: false,
    regNo1: '',
    regNo2: '',
    checkedRegNo: false, //주민번호 정상체크
    regNo: '',
  })

  const [certChkInfo, setCertChkInfo] = useState({
    signCompleted: false,
    certChkYn: 'Y',
  })

  //사용자 가입용 데이터
  const [userInfo, setUserInfo] = useState({
    jtCrtfctId: '',
    jtCrtfctDn: '',
    bgngYmd: '',
    endYmd: '',
  })

  const handleChange = (e) => {
    const { value, name } = e.target // 우선 e.target 에서 name 과 value 를 추출
    setState({
      ...state, // 기존의 input 객체를 복사한 뒤
      [name]: value, // name 키를 가진 값을 value 로 설정
    })
  }
  /**
   * 인증서 툴킷 띄우기 전에 번호 확인
   * @param regNo1
   * @param regNo2
   * @returns
   */
  const toolkitCheckRegNo = (regNo1, regNo2) => {
    /*   setState({
        ...state,
        regNo: state.regNo1 + state.regNo2 
      }) */
    if (!regNo1) {
      return props.error({ message: '주민번호 앞자리를 입력해주세요.' })
    }
    if (!regNo2) {
      return props.error({ message: '주민번호 뒷자리를 입력해주세요.' })
    }

    let checkResult = valid.isValidJuminNo(regNo1, regNo2)
    if (!checkResult) {
      return props.error({ message: '정상적인 주민등록 번호가 아닙니다.' })
    }

    props.checkedRegNo(checkResult)
  }
  const checkStepTrue = () => {
    localStorage.setItem('isSave', true)
  }
  const checkStepFalse = () => {
    localStorage.setItem('isSave', false)
  }
  /**
   * 인증서 콜백
   * @param info
   */
  const crtfctInfo = (info) => {
    //console.log(localStorage.getItem('isSave'));
    if (localStorage.getItem('isSave') === 'true') {
      props.onCrtfctfInfo(info)
      localStorage.removeItem('isSave')
    } else {
      props.delCrtfctfInfo(info)
      localStorage.removeItem('isSave')
    }
  }

  //tab
  let [step, setStep] = useState(1)

  const onSelected = (value) => {
    setStep(value)
  }

  return (
    <React.Fragment>
      <h3 className="h3-tit mt20">공동인증서 복사 안내</h3>
      <div className="cert-gray-box">
        <div className="cert-copy">
          <img className="cert-copy-img" />
          <p className="txt">
            아래의 <span>공동인증서 가져오기/내보내기 버튼</span>을 클릭 하시면,
            <br /> 공동인증서 복사 화면으로 진입합니다.
          </p>
          <p className="text-gray mt10">
            * 인증서 복사 실행하기 전, ‘TradeSign 보안모듈’ 및 ‘모바일 앱’이 먼저 설치되어야 합니다.
          </p>
          <div className="btn-block">
            {/*   <a href="#" className="btn-secondary md">
                        인증서 내보내기
                      </a> */}
            {
              <a
                className="btn-secondary md cursor"
                onClick={() => {
                  setIsKTnetOpenExport(true)
                }}
              >
                인증서 내보내기
              </a>
            }
            {/*  <a href="#" className="btn-secondary md">
                        인증서 가져오기
                      </a> */}
            {
              <a
                className="btn-secondary md cursor"
                onClick={() => {
                  setIsKTnetOpenImport(true)
                }}
              >
                인증서 가져오기
              </a>
            }
          </div>
        </div>
      </div>
      <h3 className="h3-tit">공동인증서 내보내기 방법 : PC → 모바일 기기</h3>
      <div className="cert-box">
        <dl>
          <dt>공동인증서 내보내기</dt>
          <dd>PC에서 모바일 기기로 공동인증서를 내보내는 방법을 안내드립니다.</dd>
        </dl>
      </div>
      <ol className="olist1 mt10">
        <li>
          <span>1</span>[PC] <strong>인증서 내보내기 버튼</strong> 클릭 → 인증서 선택 창에서{' '}
          <strong>모바일 기기로 이동할 인증서</strong> 선택 → 인증서 암호 입력
        </li>
        <li>
          <span>2</span>[PC] 인증코드를 입력하는 창이 열립니다.
        </li>
        <li>
          <span>3</span>[모바일 기기] 전자문서지갑 앱 실행
        </li>
        <li>
          <span>4</span>[모바일 기기] <strong>마이페이지 &gt; 인증서 복사 버튼</strong> 누르기 → 인증코드 확인
        </li>
        <li>
          <span>5</span>[PC] 인증코드 입력 → 인증서 보내기 클릭
        </li>
        <li>
          <span>6</span>[모바일 기기] 암호설정 화면에서 <strong>내보내기 한 인증서 암호를 설정</strong>합니다.
          <br /> <em className="text-gray">＊PC에서 사용하던 암호를 그대로 설정하여 사용해도 됩니다.</em>
        </li>
        <li>
          <span>7</span>[모바일 기기] 인증서 내보내기(PC→모바일 기기) 완료
          <br /> <em className="text-gray">* 내보내기한 인증서는 전자문서지갑 앱의 ‘인증서 관리‘ 메뉴에서 확인이 가능합니다.</em>
        </li>
      </ol>
      <h3 className="h3-tit">공동인증서 가져오기 방법 : 모바일 기기 → PC</h3>
      <div className="cert-box">
        <dl>
          <dt>공동인증서 가져오기</dt>
          <dd>모바일 기기에서 PC로 공동인증서를 내보내는 방법을 안내드립니다.</dd>
        </dl>
      </div>
      <ol className="olist1 mt10">
        <li>
          <span>1</span>[PC] <strong>인증서 가져오기 버튼</strong> 클릭 → 인증서 가져오기 창에서 인증코드 발급 클릭 → 인증코드
          확인
        </li>
        <li>
          <span>2</span>[모바일 기기] 전자문서지갑 앱을 실행합니다.
        </li>
        <li>
          <span>3</span>[모바일 기기] <strong>'마이페이지 → 인증서 관리 → 인증서 내보내기'</strong> 클릭 → 인증서 선택 → ‘인증서
          암호’ 입력 → ‘인증코드’ 입력
        </li>
        <li>
          <span>4</span>[모바일 기기] 인증서 내보내기 완료
        </li>
        <li>
          <span>5</span>[PC] 암호설정 화면에서 <strong>가져오기 한 인증서 암호</strong>를 설정합니다.
          <br /> <em className="text-gray">＊모바일 기기에서 사용하던 암호를 그대로 설정하여 사용해도 됩니다.</em>
        </li>
        <li>
          <span>6</span>[PC] 인증서 가져오기(모바일 기기 → PC) 완료
        </li>
      </ol>
      <KTnetModalExport
        isKTnetOpenExport={isKTnetOpenExport}
        onChangeExport={() => setIsKTnetOpenExport(false)}
        error={props.error}
      />
      <KTnetModalImport
        isKTnetOpenImport={isKTnetOpenImport}
        onChangeImport={() => setIsKTnetOpenImport(false)}
        error={props.error}
      />
      {/* <Alert /> */}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    checkedRegNo: state.regis.checkedRegNo,
  }
}

const actionCreators = {
  success: alertActions.success,
  error: alertActions.error,
  checkedRegNo: regisActions.checkedRegNo,
  onCrtfctfInfo: regisActions.onCrtfctfInfo,
  delCrtfctfInfo: regisActions.delCrtfctfInfo,
}

export default connect(mapStateToProps, actionCreators)(CrtfctStep02)
